<div class="bell-notification-view">
  <!-- *ngFor="let action of actions" -->
  <mat-menu #appMenu="matMenu">
    <button
      *ngFor="let notification of notifications$ | async"
      class="action notification action-menu-view-button"
      mat-menu-item
    >
      <div class="notification-item flex flex--row flex__align-items--center"
        (click)="viewNotification(notification)">
        <span class="notification-text">{{ notification.content }}</span>
        <span class="notification-actions">
          <mat-icon click-stop-propagation class="icon-action" (click)="deleteNotification(notification)">close</mat-icon>
        </span>
      </div>
    </button>
  </mat-menu>
  
  <button
    class="bell"
    mat-icon-button
    color="accent"
    [disabled]="false"
    [matMenuTriggerFor]="appMenu"
  >
      <mat-icon>circle_notifications</mat-icon>
      <span class="counter">{{ notificaitonsCount$ | async }}</span>
  </button>
</div>
